<template>
  <div class="container">
    <h1>Vapes The Plant</h1>
    <template v-if="vape_data_loading">
      <h3>
        Collecting Vape Data ...
      </h3>
    </template>
    <template v-else>
      <div class="row">
        <div class="col-12">
          <table class="table table-striped table-bordered table-hover table-condensed align_left">
            <thead>
            <tr>
              <th>Customer Name</th>
              <th>Plant Qty</th>
              <th>Times Ordered</th>
              <th>Date Received</th>
              <th>Last Order Days</th>
            </tr>
            </thead>
            <tbody class="align_left">
            <tr v-for="vape_pos in vape_data" v-bind:key="vape_pos.customer_id">
              <td>{{vape_pos.customer_display_name}}</td>
              <td>{{vape_pos.total_qty}}</td>
              <td>{{vape_pos.times_ordered}}</td>
              <td>{{vape_pos.last_date_received_formatted}}</td>
              <td>{{vape_pos.last_order_days}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </template>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters({
      vape_data: 'admin/vape_data',
      vape_data_loading: 'admin/vape_data_loading',
    }),
  },
  mounted() {
    this.get_vape_data();
  },
  methods: {
    get_vape_data() {
      this.$store.dispatch('admin/getVapeData');
      }
    },
}
</script>


<style scoped>

</style>

